module.exports = __webpack_public_path__ + "static/img/site3.792d742.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/site3.gif
// module id = 99t9
// module chunks = 1